module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/banner-6d74b658e05326cc6cbe8b0fde361582.svg&quot;;"